import React from 'react';
import Svg from '../Svg';
import IIconSvg from './IIconSvg';

const Left: React.FC<IIconSvg> = ({ fill = '#61656E', bgColor, size = '16px', className }) => (
  <Svg className={className} path="" fill="none" color={bgColor} size={size} viewBox="0 0 18 32">
    <path d="M16.5 31L1.5 16L16.5 1" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export default Left;
